/**
* Profile form
* Created by Min on 10/08/18
*/

import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cx from 'classnames'

// action import
import { ActionCreator } from '../../actions/'
import AppButton from '../AppButton'

// style import
import './style.scss'

const renderField = ({ input, label, type, disabled, error }) =>
{
    const dynClassInput = cx({
        'has-error': error
    })

    return (
      <div className="form-item">
        <label className="form-item__label">{label}</label>
        <div className="form-item__input">
          <input {...input} type={type} disabled={disabled} className={dynClassInput}/>
          {
            error &&
                <div className="form-item__error">{error}</div>
          }
        </div>
      </div>
    )
}



class ProfileForm extends Component {

    submitProfileForm() {
        this.props.updateProfileRequest(this.props.profileFormData)
    }

    render() {

        const { profileFormErrors, handleSubmit, submitting } = this.props

        return (
            <form
                className="profile-form"
                onSubmit={handleSubmit(::this.submitProfileForm)}
            >
                <Field
                  name="first_name"
                  type="text"
                  component={renderField}
                  label="First name"
                  error={profileFormErrors['first_name']}
                />
                <Field
                  name="email"
                  type="text"
                  component={renderField}
                  label="Email"
                  disabled='disabled'
                />
                <Field
                  name="phone"
                  type="phone"
                  component={renderField}
                  label="Phone"
                  error={profileFormErrors['phone']}
                />
                <Field
                  name="password1"
                  type="password"
                  component={renderField}
                  label="Password"
                  error={profileFormErrors['password1']}
                />
                <Field
                  name="password2"
                  type="password"
                  component={renderField}
                  label="Retype password"
                  error={profileFormErrors['password2']}
                />
                <div className="form-buttons">
                    <AppButton
                        type="submit"
                        buttonText="Save"
                        size="big"
                        color="blue"
                        disabled={submitting}
                    />
                    <AppButton
                        buttonText="Back"
                        size="big"
                        color="blue"
                        onClick={()=>{this.props.editProfile(false)}}
                    />
                </div>
          </form>
        );
    }
}

ProfileForm = reduxForm({
  form: 'profileForm', // a unique identifier for this form
})(ProfileForm);

// define the prop types
ProfileForm.propTypes = {
    initData: PropTypes.object,
}

// pull in all required props tino this container
const mapStateToProps = (state) => {
    const profileFormData = (state.form.profileForm) ? state.form.profileForm.values : {}
    const profileFormErrors = (state.form.profileForm) ? (state.form.profileForm.submitErrors ? state.form.profileForm.submitErrors : {}) : {}

    return {
        profileFormData,
        profileFormErrors,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        updateProfileRequest: action.updateProfileRequest,
        editProfile: action.editProfile
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm)



// WEBPACK FOOTER //
// ./src/components/ProfileForm/index.js